import { useRouter } from 'next/router';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { IPageStatus } from '../../config/IPageStatus';
import { useProductPageStatus } from '../../ProductProvider';
import A from '../../comps/A';
import B from '../../comps/B';
import C from '../../comps/C';
import D from '../../comps/D';
import E from '../../comps/E';
import F from '../../comps/F';
import F_CA from '../../comps/F_CA';
import G from '../../comps/G';
import H from '../../comps/H';
import I from '../../comps/I';
import I_CA from '../../comps/I_CA';
import J from '../../comps/J';
import K from '../../comps/K';
import HighlightTextAni from '../../comps/HighlightTextAni';
import FixProcess from '../../comps/FixProcess';
import Compare from '../../comps/Compare';
import Accessories from '../../comps/Accessories';
import NumberAni from '../../comps/NumberAni';
import AutoSave24Ani from '../../comps/AutoSave24Ani';
import ListAni from '../../comps/ListAni';
import App from '../../comps/App';
import Tabs from '../../comps/Tabs';
import Roof from '../../comps/Roof';
import Solutions from '../../comps/Solutions';
// import MicrosoftChatComp from '../../comps/MicrosoftChatComp';
// import { useGetChatData } from '../../comps/MicrosoftChatComp/useGetChatData';
import Choose from '../../comps/Choose';
import TNC from '../../comps/TNC';
import BottomAction from '../../comps/BottomAction';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import { useLang } from '@/i18n';

const CanMove = dynamic(() => import('../../comps/CanMove'));
const SwiperAni = dynamic(() => import('../../comps/SwiperAni'));

const Overview: React.FC<{ setActivetedTabs: any }> = ({ setActivetedTabs }) => {
    const pageStatus = useProductPageStatus();
    const { t } = useLang('dpux');
    const { locale = '' } = useRouter();
    // const { loadChat, payloadData } = useGetChatData();

    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }

    return (
        <div className={`overview ${css.page}`}>
            <BottomAction />
            <A />
            <B />
            <C />
            <FixProcess />
            {((pageStatus !== IPageStatus.REGULAR && locale === 'us') ||
                ([IPageStatus.TEASER, IPageStatus.SUPER_EARLY].includes(pageStatus) && locale === 'ca')) && <D setActivetedTabs={setActivetedTabs} />}
            <E />
            <div className="range1">
                {locale === 'ca' ? <F_CA /> : <F />}
                <G />
                <H />
                {locale === 'ca' ? <I_CA /> : <I />}
            </div>
            <div className="range2">
                {locale === 'us' && (
                    <>
                        <J />
                        <K />
                        {/* hzihhuang ⬇️ */}
                        <Compare />
                        <SwiperAni />
                        <CanMove />
                    </>
                )}
            </div>
            <div className="range3">
                <HighlightTextAni
                    title={t('HighlightTextAni3.title')}
                    desc={t.rich('HighlightTextAni3.desc', {
                        sup: (v: string) => <sup>{v}</sup>,
                    })}
                    id="delta-pro-ultra-x-O"
                />
                {locale !== 'ca' && <ListAni />}
            </div>
            <div className="range4">
                <HighlightTextAni title={t('HighlightTextAni4.title')} desc={t('HighlightTextAni4.desc')} id="delta-pro-ultra-x-Q" />
                <NumberAni />
                <AutoSave24Ani />
                <Roof />
            </div>
            <div className="range5">
                <Tabs />
            </div>
            <div className="range6">
                <App />
                {locale !== 'ca' && <Accessories />}
            </div>
            {locale === 'us' && (
                <>
                    <Solutions />
                    <Choose />
                </>
            )}
            {/* {loadChat && <MicrosoftChatComp payloadData={payloadData} />} */}
            <TNC />
        </div>
    );
};

export default Overview;
